var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHowItWorksGetPaid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 62,
    viewBox: "0 0 64 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 61.9522,
    rx: 12,
    fill: "#6395EE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.4569 49.9522H25.1059C23.1514 49.9505 21.5659 48.3667 21.5642 46.4106V43.6575C21.1902 44.2977 12.85 30.0032 12.5149 29.6762C11.509 28.0149 12.0212 25.8515 13.6657 24.8186L33.5406 12.5238C35.207 11.5011 37.3839 12.0217 38.4065 13.6864C39.2843 15.3781 46.4586 26.0773 46.8274 27.7401H48.455L48.4567 27.7418C50.4129 27.7435 51.9966 29.3273 52 31.2834V46.4103C51.9966 48.3665 50.4131 49.9505 48.4569 49.9522ZM24.26 38.2657V46.4105C24.26 46.8789 24.6391 47.2563 25.1058 47.258H48.4569C48.9253 47.2563 49.3044 46.8789 49.3044 46.4105V38.2657H24.26ZM35.3906 14.6972C35.2372 14.6955 35.0856 14.7376 34.9542 14.8185L15.0909 27.1046C14.9005 27.2209 14.764 27.4096 14.7118 27.6252C14.6578 27.8426 14.6949 28.0717 14.8112 28.2621L21.5641 39.18V31.2828C21.5658 29.3266 23.1513 27.7428 25.1058 27.7411H43.9412L36.1117 15.0992C35.9583 14.8481 35.6854 14.6948 35.3905 14.6965L35.3906 14.6972ZM24.26 35.5698H49.3041V31.2835C49.3041 30.8168 48.925 30.4377 48.4566 30.4377H25.1055C24.6388 30.4377 24.2597 30.8168 24.2597 31.2835L24.26 35.5698ZM45.9565 45.0186H43.5774C42.8327 45.0186 42.2295 44.4138 42.2295 43.6707C42.2295 42.926 42.8327 42.3228 43.5774 42.3228H45.9565C46.6928 42.3329 47.2859 42.9327 47.2859 43.6707C47.2859 44.407 46.6928 45.0069 45.9565 45.0186Z",
    fill: "#EFF7FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowItWorksGetPaid);
export default __webpack_public_path__ + "static/media/HowItWorksGetPaid.9e8a6e0bd0778fe0f0b288392fb55ffc.svg";
export { ForwardRef as ReactComponent };